import { useRouter } from 'next/router';
import styled from 'styled-components';
import { VipAndLatestAdsSkeletonLoader } from './VipAndLatestAdsSkeletonLoader';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import * as DesktopFiltersStyles from '@/components/Filters/DesktopFilters/DesktopFilters.styles';
import * as CategoryFilterStyles from '@/components/Filters/DesktopFilters/CategoryDesktopFilter.styles';
import * as HeaderStyles from '@/components/Filters/DesktopFilters/DesktopFiltersHeader.styles';
import { SUBCATEGORY_SLUG_INDEX } from '@/hooks/useCurrentCategory/useCurrentCategory.constants';

const Wrapper = styled.div`
  display: flex;
  gap: 35px;
  margin-top: 15px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    margin-top: 0;
  }
`;

const SidebarHidden = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

const AdsListContainer = styled.div`
  width: 100%;
`;

const SortSkeletonContainer = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    margin-bottom: 15px;
  }
`;

const FiltersSkeleton = ({ isSubcategories }: { isSubcategories: boolean }) => (
  <DesktopFiltersStyles.Container>
    <CategoryFilterStyles.Container>
      <CategoryFilterStyles.ParentCategoryLoader>
        <SkeletonLoader width={100} height={18} borderRadius={7} />
      </CategoryFilterStyles.ParentCategoryLoader>
      <CategoryFilterStyles.CurrentCategoryLoader>
        <SkeletonLoader width={150} height={18} borderRadius={7} />
      </CategoryFilterStyles.CurrentCategoryLoader>
      {!isSubcategories &&
        Array.from({ length: 14 }, (_, i) => (
          <CategoryFilterStyles.CategoryLoader key={i}>
            <SkeletonLoader width={150} height={18} borderRadius={7} />
          </CategoryFilterStyles.CategoryLoader>
        ))}
    </CategoryFilterStyles.Container>

    <DesktopFiltersStyles.FiltersContainer>
      <HeaderStyles.Container>
        <SkeletonLoader width={65} height={17} borderRadius={7} />
        <SkeletonLoader width={65} height={17} borderRadius={7} />
      </HeaderStyles.Container>

      <DesktopFiltersStyles.DesktopFilterLoaderContainer>
        <DesktopFiltersStyles.DesktopFilterLoaderRow>
          <SkeletonLoader width={80} height={20} borderRadius={7} />
          <SkeletonLoader width={20} height={20} borderRadius={7} />
        </DesktopFiltersStyles.DesktopFilterLoaderRow>
        <DesktopFiltersStyles.DesktopFilterLoaderRow>
          <SkeletonLoader width={127.5} height={44} borderRadius={14} />
          <SkeletonLoader width={127.5} height={44} borderRadius={14} />
        </DesktopFiltersStyles.DesktopFilterLoaderRow>
      </DesktopFiltersStyles.DesktopFilterLoaderContainer>

      <DesktopFiltersStyles.DesktopFilterLoaderContainer>
        <DesktopFiltersStyles.DesktopFilterLoaderRow>
          <SkeletonLoader width={80} height={20} borderRadius={7} />
          <SkeletonLoader width={20} height={20} borderRadius={7} />
        </DesktopFiltersStyles.DesktopFilterLoaderRow>
      </DesktopFiltersStyles.DesktopFilterLoaderContainer>
    </DesktopFiltersStyles.FiltersContainer>
  </DesktopFiltersStyles.Container>
);

export const SearchPageSkeleton = () => {
  const { query } = useRouter();
  const isSubcategories =
    Array.isArray(query.slug) &&
    query.slug.length === SUBCATEGORY_SLUG_INDEX + 1;

  return (
    <Wrapper>
      <SidebarHidden>
        <FiltersSkeleton isSubcategories={isSubcategories} />
      </SidebarHidden>
      <AdsListContainer>
        <SortSkeletonContainer>
          <SkeletonLoader width={225} height={45} borderRadius={14} />
        </SortSkeletonContainer>
        <VipAndLatestAdsSkeletonLoader />
      </AdsListContainer>
    </Wrapper>
  );
};
